module.exports = __webpack_public_path__ + "static/media/Wakefield-whistleblowing-appendix-1-six-categories-wrongdoing-1.094d2757.pdf";